import { isVNode as o, Comment as i, Fragment as l } from "vue";
function n(e) {
  return e.some((r) => o(r) ? !(r.type === i || r.type === l && !n(r.children)) : !0) ? e : null;
}
function p(e, r) {
  return e && n(e()) || r();
}
function c(e, r, t) {
  return e && n(e(r)) || t(r);
}
function m(e, r) {
  const t = e && n(e());
  return r(t || null);
}
function s(e, r, t) {
  const u = e && n(e(r));
  return t(u || null);
}
function a(e) {
  return !(e && n(e()));
}
export {
  n as ensureValidVNode,
  a as isSlotEmpty,
  p as resolveSlot,
  c as resolveSlotWithTypedProps,
  m as resolveWrappedSlot,
  s as resolveWrappedSlotWithProps
};
